import { put, takeLatest } from 'redux-saga/effects';
import { APP_ACTIONS } from './utils';
import { setCurrentUser } from './reducer';
import { getUser } from '@/api/requests/endpoints/GET/getUser';
import { sagaNavigator } from '@/utils/navigator';
import { APP_ROUTES } from '@/utils/appRoutes';

function* initUserSaga() {
  try {
    const data = yield getUser();
    if (!data) {
      throw new Error('Missing User');
    }
    yield put(setCurrentUser(data));
  } catch (e) {
    console.log(e);
    yield sagaNavigator(APP_ROUTES.LOGIN);
  }
}

export function* appSaga() {
  yield takeLatest(APP_ACTIONS.INIT_USER, initUserSaga);
}
